module.exports = __webpack_public_path__ + "img/banner2.4aa7073b.png";